/**
 * 格式化文本内容，去除HTML标签并截取指定长度
 * @param {string} content 原始内容
 * @param {number} length 需要截取的长度，默认30
 * @returns {string} 处理后的文本
 */
export function formatContent(content, length = 100) {
  if (!content) return '';
  // 移除HTML标签，只保留文本
  const text = content.replace(/<[^>]+>/g, '');
  return text.length > length ? text.substring(0, length) : text;
}
